import { DetailsInterface } from '@/core/domain/details/models/details.model';
import { DetailsRepository } from '@/core/domain/details/repositories/details.repository';
import { ReservationDetailsRequest } from '@/core/domain/details/usecases/getDetails.usecase';
import { environment } from '@/env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DetailsImplRepository extends DetailsRepository {
    constructor(private readonly httpClient: HttpClient) {
        super();
    }

    override getDetails(
        reservationDetails: ReservationDetailsRequest,
    ): Observable<DetailsInterface> {
        return this.httpClient.get<DetailsInterface>(
            [
                environment.alamoApi.BASE_HOST,
                environment.alamoApi.ENDPOINTS.details,
            ].join('/'),
            {
                params: {
                    reservationCode: reservationDetails.reservationCode,
                    lastName: reservationDetails.lastName,
                },
            },
        );
    }
}
